import React,{useState, useEffect}  from 'react';
import {Card} from 'react-bootstrap'
import Sides from '../Bars/Diffjvscs';

import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Jcswhile(){


  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  



return(
    <div>
          <Sides/>
      <Helmet>
 
 <title>Difference Between Java and C# While tutorial For Beginners</title>
<meta name="description" content="Difference Between Java and C# While tutorial for beginners.CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners and  questions of all technology like java tutorial, java tutorial,c# tutorial for beginners in deeply knowledge With Deeply" />
<meta name="keywords" content="codeexampler,programming language,While,tutorial for begineers,Difference Between Java and Csharp(C#),Difference between program and code,java tutorial for begineers,C# tutorial for begineers,java tutorial for begineers,code,exampler,which online website to learn code,Difference Between Java and C# ,java vs c#,java vs Python" />
<link rel="canonical" href="https://www.codeexampler.com/java-vs-csharp-while" />
</Helmet>

<div className='lg:pl-56'>


    <h1 className="m-4 mh1">Java vs C# While loop</h1>
    <div className="first">
        <a href="/java-vs-csharp-switch">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/java-vs-csharp-function">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <p className="mt-3 para">This condition will be given and the body of the loop will be executed until the given condition is false</p>
   
<h2 className="mt-4 mh2">
 Java While loop Syntax</h2>

<Card className='inde' border='primary m-4'>
  <Card.Header as="h5">while loop java syntax</Card.Header>
  <Card.Body>
    <Card.Text>
    While (condition) <br/>
    statement<br/>
    &#123;<br/>
body<br/>
&#125;<br/>
    </Card.Text>
  </Card.Body>
</Card>

<h2 className="mt-4 mh2">
C# While loop Syntax</h2>

<Card className='inde' border='primary m-4'>
  <Card.Header as="h5">while loop C# syntax</Card.Header>
  <Card.Body>
    <Card.Text>
        namespace while <br/>
        &#123;<br/>
    While (condition) <br/>
    statement<br/>
    &#123;<br/>
body<br/>
&#125;<br/>
&#125;<br/>
    </Card.Text>
  </Card.Body>
</Card>

<h3 className="mt-4">java while loop Example </h3>


<Card className='inde' border='primary m-4'>
  <Card.Header as="h5">while loop java Example</Card.Header>
  <Card.Body>
  
    <Card.Text>
    public class Whileloop_example&#47;&#47; class is a keyword<br/>
    &#123;<br/>
    public static void main(String[] args) 
&#123;<br/>
int a=1;<br/>
while(a&#60;=10)<br/>
&#123;<br/>
System.out.println(a);<br/>
a++;<br/><br/>
OR<br/><br/>
a=a+1;<br/>
&#125;<br/>
&#125;<br/>
&#125;<br/>
    </Card.Text>
  </Card.Body>
  <Card.Footer >Output-1<br/>
2<br/>
3<br/>
4<br/>
5<br/>
6<br/>
7<br/>
8<br/>
9<br/>
10</Card.Footer>
</Card>

<h3 className="mt-4">c# while loop Example </h3>

<Card className='inde' border='primary m-4'>
  <Card.Header as="h5">while loop C# Example</Card.Header>
  <Card.Body>
  
    <Card.Text>
    namespace While_loop<br/>
    &#123;<br/>
    class Program<br/>
    &#123;<br/>
        static void Main(string[] args)<br/>
        &#123;<br/>
   
        int a = 1;<br/>
        while(a&#60;=10)<br/>
&#123;<br/>
Console.WriteLine(a);<br/>
                a++;<br/><br/>
OR<br/><br/>
a = a + 1;<br/>
&#125;<br/>
&#125;<br/>
&#125;<br/>
&#125;<br/>
    </Card.Text>
  </Card.Body>
  <Card.Footer >Output-<br/>1<br/>
2<br/>
3<br/>
4<br/>
5<br/>
6<br/>
7<br/>
8<br/>
9<br/>
10</Card.Footer>
</Card>

<h1 className="mt-5">  </h1>
      
<div className="back">
        <a href="/java-vs-csharp-switch">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/java-vs-csharp-function">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    </div>
    </div>
)

}
export default Jcswhile;